module.exports = "/packs/012-f2bf2f97de2e4f578223f23b4f11c483.jpg";